import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import TranslateIcon from '@mui/icons-material/Translate';
import { useLanguage } from '../contexts/LanguageContext';

// Bump this when there's a new announcement to show again.
const ANNOUNCEMENT_ID = '1.1.0';
const STORAGE_KEY = 'vamos-tamos-whatsnew';
// Only promote this announcement until the end of September 2026.
const EXPIRES_AT = new Date('2026-10-01T00:00:00').getTime();

function WhatsNew() {
  const { translate } = useLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (Date.now() >= EXPIRES_AT) return; // promotion window is over
    try {
      if (localStorage.getItem(STORAGE_KEY) !== ANNOUNCEMENT_ID) {
        setOpen(true);
      }
    } catch (e) {
      // localStorage unavailable (private mode etc.) — skip silently.
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, ANNOUNCEMENT_ID);
    } catch (e) {
      // ignore write failures
    }
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={dismiss} fullWidth maxWidth="xs">
      <DialogTitle>{translate('whatsNew.title')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {translate('whatsNew.intro')}
        </Typography>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <GroupsIcon color="primary" />
            <Box>
              <Typography variant="subtitle2">{translate('whatsNew.teamsTitle')}</Typography>
              <Typography variant="body2" color="text.secondary">
                {translate('whatsNew.teamsBody')}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <TranslateIcon color="primary" />
            <Box>
              <Typography variant="subtitle2">{translate('whatsNew.languagesTitle')}</Typography>
              <Typography variant="body2" color="text.secondary">
                {translate('whatsNew.languagesBody')}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={dismiss}>
          {translate('whatsNew.cta')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WhatsNew;
